import Layout from './components/Layout';

export default Layout;

export const pageQuery = graphql`
    query Layout {
        site {
            siteMetadata {
                languages {
                    defaultLangKey
                    langs
                }
            }
        }
        footerRu: contentfulBlock(name: {eq: "footer"}, node_locale: {eq: "ru"}) {
            ...FooterContacts
        }
        footerEn: contentfulBlock(name: {eq: "footer"}, node_locale: {eq: "en"}) {
            ...FooterContacts
        }
    }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js